export const getCryptedString = (str: string) => {
  return str
    .split('')
    .map(value => value.charCodeAt(0) ^ 1)
    .join('');
}